export default "__VITE_ASSET__B9hhpt6Y__"